import Model from './Model';

export default class Trajectory extends Model {
    client;
    counselor;
    trajectory_state;
    registered_by;
    contact_name;
    contact_phone;
    contact_email;
    registration_date;
    intake_date;
    category;
    length;
    schooling;
    apq_taken;

    static apiPath() {
        return 'trajectories';
    }

    toJson() {
        // When submitting an change, we need to send id's for the relations instead of the values themselves.
        const dtoIds = {
            counselor_id: this.counselor.id,
            organisation_id: this.organisation.id,
            trajectory_state_id: this.trajectory_state.id
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/Trajectory.js